import gql from "graphql-tag"

export default gql`
  fragment ShowSearchFragment on Show {
    id
    name
    tmdbOptions
    status
 }
`